import { useTranslation } from '@chr/online-shared-ui-localizations';
import Grid from '@mui/material/Grid';
import { TrackingInfoItem } from '../../common/components/TrackingInfoItem/TrackingInfoItem';
import '../../common/utilities/Section.scss';
import { Job } from '../../common/apis/dtos';
import {
  FormatLocation,
  IsoToDateAtTime,
} from '../../common/utilities/display-utilities';

declare interface SurfaceCarrierSummaryProps {
  shipment: Job;
  isMobileScreen: boolean;
}

export const SurfaceCarrierSummary = ({
  shipment,
  isMobileScreen,
}: SurfaceCarrierSummaryProps) => {
  const translate = useTranslation();

  const carrierItem = () => {
    return (
      <Grid
        container
        spacing={2}
        className="carrier-summary-section"
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
      >
        <Grid item xs={isMobileScreen ? 12 : 4}>
          <TrackingInfoItem
            title={translate('Carrier')}
            information={shipment.carrierName}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 4}>
          <TrackingInfoItem
            title={translate('Last Known Location')}
            information={FormatLocation(shipment.currentLocation?.location)}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 4}>
          <TrackingInfoItem
            title={translate('Date And Time')}
            information={IsoToDateAtTime(
              shipment.currentLocation?.lastUpdateDateTime,
              translate
            )}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <div data-testid="surface-carrier-summary" className="section">
      <div className="section-heading">{translate('Carrier Summary')}</div>
      <div className={isMobileScreen ? 'section-body-mobile' : 'section-body'}>
        {carrierItem()}
      </div>
    </div>
  );
};
